import { render } from "./MatrizesTableView.vue?vue&type=template&id=13120a12"
import script from "./MatrizesTableView.vue?vue&type=script&lang=js"
export * from "./MatrizesTableView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Workspace\\SalvandoArvores\\Codes\\salvando-arvores-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__